const root = document.documentElement;
const nav = document.querySelector('#navbar-main');
const container = nav.querySelector('.container');

const containerPadding = getComputedStyle(
  document.documentElement
).getPropertyValue('--container-gutter');

const containerPaddingMobile = getComputedStyle(
  document.documentElement
).getPropertyValue('--container-gutter-mobile');

const menuDropdownWidth = () => {
  let containerWidth = container.clientWidth;

  if (window.innerWidth >= 992) {
    containerWidth -=
      parseInt(containerPadding, 10) + parseInt(containerPadding, 10);
  } else {
    containerWidth -=
      parseInt(containerPaddingMobile, 10) +
      parseInt(containerPaddingMobile, 10);
  }

  root.style.setProperty('--dropdown-width', `${containerWidth}px`);
};

export default menuDropdownWidth;
